import { jsx as _jsx } from "react/jsx-runtime";
import { Box } from '@mui/material';
import GlobeLoader from "./main-loader.gif";
const ImageLoader = ({ height = '100px', width = '100px' }) => {
    return (_jsx(Box, { sx: { display: "flex", justifyContent: "center", alignItems: "center", height: "100%" }, children: _jsx("img", { src: GlobeLoader, alt: 'Loading...', style: { height, width } }) }));
};
export default ImageLoader;
